import React, { useState } from 'react';
import {
  Table, TableHead, TableBody, TableCell, TableRow, makeStyles,
} from '@material-ui/core';
import Box from '@material-ui/core/Box';
import Collapse from '@material-ui/core/Collapse';
import Typography from '@material-ui/core/Typography';
import { connect } from 'react-redux';
import { CommonButton } from '../../CommonComponents';
import CommonAlert from '../../CommonComponents/CommonAlert';
import { removeAssingedProduct } from '../../redux/actions/dashusers';

const useStyles = makeStyles((theme) => ({
  problemWithSite: {
    backgroundColor: theme.palette.warning.main,
  },
  regularRow: {},
}))
const ProductUsersSubTable = ({
  id, open, users,
  removeProduct,
}) => {
  const classes = useStyles();

  const [localState, setLocalState] = useState({
    alert: false,
    userId: '',
  })

  const removeMapping = () => {
    const { userId } = localState
    removeProduct(userId, id, 2)
    setLocalState({ alert: false, userId: '' })
  }

  if (users === undefined || users === null) { return null }
  return (
    <>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={12}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            {users.length ? (
              <Box margin={1}>
                <Table size="small" aria-label="purchases">
                  <TableHead>
                    <TableRow>
                      <TableCell><b>Manager Name</b></TableCell>
                      <TableCell><b>Email</b></TableCell>
                      <TableCell><b>Action</b></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {users.map((user) => (
                      <TableRow
                        key={user.id}
                        className={classes.regularRow}
                      >
                        <TableCell component="th" scope="row">
                          {user.full_name}
                        </TableCell>
                        <TableCell>
                          {user.email}
                        </TableCell>
                        <TableCell>
                          <CommonButton
                            basic="true"
                            color="primary"
                            onClick={() => setLocalState({ alert: true, userId: user.id })}
                          >
                            <b>Remove</b>
                          </CommonButton>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Box>
            ) : (
              <Box margin={1}>
                <Typography variant="h6" gutterBottom component="div">No users available</Typography>
              </Box>
            )}
          </Collapse>
        </TableCell>
      </TableRow>
      {localState.alert
        ? (
          <CommonAlert
            title="Are you sure?"
            onClose={() => setLocalState({ alert: false, userId: '' })}
            onAgree={removeMapping}
          />
        )
        : null}
    </>
  );
}

const mapActions = {
  removeProduct: removeAssingedProduct,
};

export default connect(null, mapActions)(ProductUsersSubTable);
